<template>
  <div class="htchart">
    <div id="myChart10"></div>
    <div class="legend">
      <el-descriptions class="margin-top" :column="1" :colon="false">
        <el-descriptions-item label="开发合同" labelClassName="Achievement">
          <span class="Proportion">占比</span>
          <span class="ProportionNum">19%</span>
          <span class="ProportionNum1">74.18</span>
          <span class="Ymoney">亿元</span>
        </el-descriptions-item>
        <el-descriptions-item label="转让合同" labelClassName="DemandRow">
          <span class="Proportion">占比</span>
          <span class="ProportionNum">6%</span>
          <span class="ProportionNum1">24.32</span>
          <span class="Ymoney">亿元</span>
        </el-descriptions-item>
        <el-descriptions-item label="咨询合同" labelClassName="PersonnelRegRow">
          <span class="Proportion">占比</span>
          <span class="ProportionNum">5%</span>
          <span class="ProportionNum1">19.37</span>
          <span class="Ymoney">亿元</span>
        </el-descriptions-item>
        <el-descriptions-item label="服务合同" labelClassName="PersonnelRegRow1">
          <span class="Proportion">占比</span>
          <span class="ProportionNum">70%</span>
          <span class="ProportionNum1">266.62</span>
          <span class="Ymoney">亿元</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {
    this.drawLine()
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart10 = this.$echarts.init(document.getElementById('myChart10'))
      // 绘制图表
      //// console.log("drawLine");
      //// console.log(myChart10);
      myChart10.setOption({
        series: [
          {
            // name: 'Nightingale Chart',
            type: 'pie',
            radius: ['40%', '100%'],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 0,
            },
            label: { show: false },
            data: [
              { value: 19, itemStyle: { color: '#6E43E2' }, name: '开发合同' },
              { value: 6, itemStyle: { color: '#2769DC' }, name: '转让合同' },
              { value: 5, itemStyle: { color: '#4CD3E2' }, name: '咨询合同' },
              { value: 70, itemStyle: { color: '#5BE391' }, name: '服务合同' },
            ],
          },
        ],
      })
      //// console.log(myChart10);
    },
  },
}
</script>

<style lang="scss" scoped>
#myChart10 {
  width: 11.4375rem;
  height: 11.625rem;
}
.htchart {
  display: flex;
  .legend {
    width: 21.5rem;
    margin-left: 4.5625rem;
    /deep/.el-descriptions-item__container {
      position: relative;
      padding-bottom: 0.3125rem;
    }
  }
  /deep/.Achievement::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #6e43e2;
    position: absolute;
    left: -1.125rem;
    top: 0.5rem;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/.DemandRow::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #2769dc;
    position: absolute;
    left: -1.125rem;
    top: 0.5rem;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/.PersonnelRegRow::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #4cd3e2;
    position: absolute;
    left: -1.125rem;
    top: 0.5rem;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/.PersonnelRegRow1::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #5be391;
    position: absolute;
    left: -1.125rem;
    top: 0.5rem;
    border-radius: 50%;
    opacity: 1;
  }
  .Proportion {
    padding-left: 1.6875rem;
    /* padding-right: 0.8rem; */
  }
  .ProportionNum {
    width: 3.125rem;
    font-weight: bold;
    padding-left: 1.7rem;
    font-size: 1rem;
    font-family: MicrosoftYaHei-Bold;
    color: #2769dc;
    position: relative;
  }
  .ProportionNum1 {
    width: 3.375rem;
    font-weight: bold;
    margin-left: 2.375rem;
    /* padding-right: 1rem; */
    font-size: 1rem;
    font-family: MicrosoftYaHei-Bold;
    color: #2769dc;
    position: relative;
  }
  .ProportionNum::after {
    content: '';
    width: 0.0625rem;
    height: 1rem;
    background: #cccccc;
    position: absolute;
    left: 4.975rem;
    top: 0.1875rem;
    border-radius: 50%;
    opacity: 1;
  }
  .Ymoney {
    padding-left: 0.625rem;
  }
}
/deep/ .el-descriptions {
  font-size: 0.875rem;
}
</style>
